<template>
	<div>
		<date-filter class="date-options with-picker"></date-filter>
		<date-range-picker
			:start="startDate"
			:end="endDate"
			:picker="picker"
			position="is-bottom-left"
			@apply="setReportDate"
		/>
	</div>
</template>

<script>
import { date_server } from "@lab/utils/format";
import startOfMonth from "date-fns/startOfMonth";
import { mapGetters, mapActions } from "vuex";

export default {
	name: "DateRangeFilter",
	computed: {
		...mapGetters({
			dateRange: "reportQueries/dateRange",
			startDate: "reportQueries/startDate",
			endDate: "reportQueries/endDate",
			dateOptions: "reportFilters/dateOptions"
		}),
		picker() {
			return this.dateRange === "custom";
		}
	},
	watch: {
		dateRange(value) {
			if (value === "custom") {
				const date = startOfMonth(new Date());
				this.setStartDate(date_server(date));
				this.setEndDate(date_server(new Date()));
			}
		}
	},
	mounted() {
		if (!this.dateOptions.find((o) => o.value === "custom")) {
			this.addDateOption({ label: "Custom range", value: "custom" });
		}
	},
	methods: {
		...mapActions({
			setStartDate: "reportQueries/setStartDate",
			setEndDate: "reportQueries/setEndDate",
			setReportDate: "reportQueries/setReportDate",
			addDateOption: "reportFilters/addDateOption"
		})
	}
};
</script>

<style scoped>
.date-options.with-picker {
	margin-right: 1em;
}
</style>
